import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import {createDesignation,deleteDesignation,fetchAllDesignations,updateDesignation,} from "../../../core/data/redux/designation/designationAction";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {exportToCSV,exportToExcel, exportToPDF} from "../../../core/common/GlobalFunctions/exportTableData";
import { Drawer, message } from "antd";
import { departmentName, status as DepartmentStatus } from "../../../core/common/selectoption/selectoption";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { designation } from "../../../core/data/json/designation";
import { decryptData } from "../../../core/utils/encryptUtils";

const Designations = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [designationName, setDesignationName] = useState<string>("");
  const [designationDescription, setDesignationDescription] =
    useState<string>("");
  const { user } = useSelector((state: any) => state.auth);
  const { departments } = useSelector((state: any) => state.department);
  const { designations, loadingStates } = useSelector((state: any) => state.designation);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
  const departmentData = filterByStatus(departments, 'active', 'Status');
  const designationsId = selectedRowData?.DesignationId;
  const [errors, setErrors] = useState<any>({});
  const [status, setStatus] = useState<string>("");

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd = permissions.includes("Add") || permissions.includes("AllowAll");
  const canView = permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit = permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete = permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport = permissions.includes("Export") || permissions.includes("AllowAll");

  const handleDepartmentChange = (event: any) => {
    setSelectedDepartment(event.target.value);
  };

  const resetFields = () => {
    setDesignationName("");
    setDesignationDescription("");
    setSelectedDepartment("");
    setSelectedRowData(null);
  };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetFields();
    setErrors({});
  };

  const handleEditDesignation = (record: any): void => {
    setSelectedRowData(record);
    setErrors({});
  };

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      Name: "",
      Description: "",
    };

    if (!designationName.trim()) {
      formIsValid = false;
      newErrors.Name = "Designation name is required.";
    }
    if (!status.trim()) {
      formIsValid = false;
      newErrors.status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    const designationData = {
      Name: designationName,
      DepartmentId: null,
      Description: designationDescription,
      Status: status,
      CreatedBy: user?.UserId,
      ModifiedBy: user?.UserId,
    };

    if (modalType === "create") {
      const result = await dispatch(createDesignation(designationData));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Designation created successfully");
        resetFields();
        await dispatch(fetchAllDesignations());
        setTableKey((prevKey) => prevKey + 1);
      } else if (result.meta.requestStatus === "rejected") {
        message.error(result.payload.error);
      }
    } else if (modalType === "edit" && designationsId) {
      const result = await dispatch(
        updateDesignation({ id: designationsId, data: designationData })
      );
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Designation updated successfully");
        await dispatch(fetchAllDesignations());
        setTableKey((prevKey) => prevKey + 1);
        resetFields();
      } else if (result.meta.requestStatus === "rejected") {
        message.error(result.payload.error);
      }
    }
    handleCancel();
  };

  const handleDeleteDesignation = async (designationId: number) => {
    try {
      const result = await dispatch(deleteDesignation(designationId));
      if (result.meta.requestStatus === "fulfilled") {
        message.success(result.payload.message);
        setIsDeleteModalVisible(false);
        await dispatch(fetchAllDesignations());
        setTableKey((prevKey) => prevKey + 1);
      } else {
        message.error(result.payload.error);
      }
    } catch (error) {
      alert("Something went wrong");
    }
  };
  useEffect(() => {
    designations.length === 0 && dispatch(fetchAllDesignations());
  }, [departments.length, designations.length, dispatch]);

  useEffect(() => {
    if (modalType === "edit" && designationsId) {
      setDesignationName(selectedRowData?.DesignationName);
      setDesignationDescription(selectedRowData?.DesignationDescription);
      setStatus(selectedRowData?.DesignationStatus);
    }
  }, [designationsId, modalType, selectedRowData]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = designations ? designations : [];

  const exportDesignations = data?.map((designation: any) => ({
    DesignationId: designation.DesignationId,
    DesignationName: designation.DesignationName || "N/A",
    DesignationDescription: designation.DesignationDescription || "N/A",
    DesignationStatus: designation.DesignationStatus,
    CreatedAt: designation.CreatedAt ? new Date(designation.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    TotalEmployees: designation.TotalEmployees ?? 0,
  }));

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { DesignationStatus: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, designations]);

  const columns = [
    {
      title: "Designation",
      dataIndex: "DesignationName",
      render: (text: String, record: any) => (
        <h6 className="fw-medium fs-14 text-dark">{text}</h6>
      ),
      sorter: (a: any, b: any) =>
        a.DesignationName.length - b.DesignationName.length,
    },
    {
      title: "No of Employees",
      dataIndex: "TotalEmployees",
      sorter: (a: any, b: any) => a.TotalEmployees - b.TotalEmployees,
    },
    {
      title: "Status",
      dataIndex: "DesignationStatus",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.DesignationStatus.length - b.DesignationStatus.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Button */}
          <button
            className="me-2"
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditDesignation(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canEdit ? "Permission Denied" : "Edit"}
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete Button */}
          <button
            onClick={() => {
              if (!canDelete || record.DesignationStatus === "inactive") return;
              setSelectedRowData(record);
              setIsDeleteModalVisible(true);
            }}
            className="me-2"
            disabled={!canDelete || record.DesignationStatus === "inactive"}
            style={{
              cursor:
                !canDelete || record.DesignationStatus === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity:
                !canDelete || record.DesignationStatus === "inactive" ? 0.5 : 1,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={
              !canDelete
                ? "Permission Denied"
                : record.DesignationStatus === "inactive"
                  ? "Designation is inactive"
                  : "Delete"
            }
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Designations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Designations
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                {canExport && (
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportDesignations, "designantion_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportDesignations, "designation_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportDesignations, "designation_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className="mb-2">
                {canAdd && (
                  <button
                    onClick={() => showModal("create")}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Designation
                  </button>
                )}
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Designation List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  {/* <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Department
                  </Link> */}
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Finance
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Application Development
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus?.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Designation */}
      <Drawer
        title={modalType === "edit" ? "Edit Designation" : "Add Designation"}
        placement="right"
        width={400}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Designation Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    value={designationName}
                    onChange={(e) => setDesignationName(e.target.value)}
                    className="form-control"
                  />
                  {errors.Name && (
                    <div style={{ color: "red" }}>{errors.Name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Status</label>{" "}
                  <span className="text-danger ms-2">*</span>
                  <select
                    className="form-control"
                    name="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    {DepartmentStatus?.map((status: any) => (
                      <option key={status.value} value={status.value}>
                        {status.label}
                      </option>
                    ))}
                  </select>
                  {errors.status && (
                    <div style={{ color: "red" }}>{errors.status}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">
                  Description
                </label>
                <input
                  type="text"
                  name="department-description"
                  value={designationDescription}
                  onChange={(e) => setDesignationDescription(e.target.value)}
                  className="form-control"
                />
                {errors.Description && (
                  <div style={{ color: "red" }}>{errors.Description}</div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit} disabled={isLoading}>
              {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit" ? "Update Designation" : "Add Designation"}
            </button>
          </div>
        </form>
      </Drawer>
      {/* /Add Designation */}

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.DesignationId &&
          handleDeleteDesignation(selectedRowData.DesignationId)
        }
      />
    </>
  );
};
export default Designations;
